import { PaymentMode, SelectedPaymentMode } from '@checkout-v2/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomCheckoutState, StateWithCustomCheckout } from '../checkout-state';
import { getCustomCheckoutState } from './feature.selector';

export const paymentModesListState: MemoizedSelector<
  StateWithCustomCheckout,
  StateUtils.LoaderState<PaymentMode[]>
> = createSelector(getCustomCheckoutState, (state: CustomCheckoutState) => {
  return state.paymentModesList;
});

export const paymentModesListValue: MemoizedSelector<StateWithCustomCheckout, PaymentMode[]> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderValueSelector(state.paymentModesList) || [],
);

export const paymentModesListLoading: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderLoadingSelector(state.paymentModesList),
);

export const paymentModesListSuccess: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderSuccessSelector(state.paymentModesList),
);

export const paymentModesListError: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderErrorSelector(state.paymentModesList),
);

export const activePaymentModeValue: MemoizedSelector<StateWithCustomCheckout, SelectedPaymentMode | undefined> =
  createSelector(getCustomCheckoutState, (state: CustomCheckoutState) =>
    StateUtils.loaderValueSelector(state.activePaymentMode),
  );

export const activePaymentModeLoading: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderLoadingSelector(state.activePaymentMode),
);

export const activePaymentModeSuccess: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderSuccessSelector(state.activePaymentMode),
);

export const activePaymentModeError: MemoizedSelector<StateWithCustomCheckout, boolean> = createSelector(
  getCustomCheckoutState,
  (state: CustomCheckoutState) => StateUtils.loaderErrorSelector(state.activePaymentMode),
);
